module.exports = __webpack_public_path__ + "static/media/Velasca - Bordeaux_Sand.43b2c375.jpg";